
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp-yaris-cross-360",
      function () {
        return require("private-next-pages/lp-yaris-cross-360.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp-yaris-cross-360"])
      });
    }
  